import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';
import {
	TQC3020_R01SalesDto,
	TQC3020_R01SalesLotDto,
	TQC3020_R01ProductBaseDto,
	TQC3020_R01ProductLotDto,
	TQC3020_R01ProductResultDto,
	TQC3020_R01BomDto,
	TQC3020_R01StockDto,
	TQC3020_R01SalesFilter,
	TQC3020_R01ProductBaseFilter,
	TQC3020_R01ProductResultFilter,
	TQC3020_R01StockFilter,
} from './Dto_TQC3020_R01';
import { getFutureWeekdayExceptTodayAndTomorrow } from 'src/utils/date/dateUtils';

export type TQC3020_R01_TabType = 'sales' | 'product';

export type TQC3020ScrollTopKey =
	| 'sales'
	| 'salesLot'
	| 'product'
	| 'productLot'
	| 'productResult'
	| 'bom'
	| 'stock';

export interface TQC3020ScrollTop {
	sales: number | null;
	salesLot: number | null;
	product: number | null;
	productLot: number | null;
	productResult: number | null;
	bom: number | null;
	stock: number | null;
}

const defaultTQC3020ScrollTop = (): TQC3020ScrollTop => ({
	sales: null,
	salesLot: null,
	product: null,
	productLot: null,
	productResult: null,
	bom: null,
	stock: null,
});

export interface TQC3020_R01Filter {
	// 매출기준 필터
	salesDateRange: DateRange | undefined;
	salesCompCdCondition: string;
	salesCustomCdCondition: string;
	salesItemCd: string;
	salesItemNm: string;
	
	// 생산기준 필터
	productDateRange: DateRange | undefined;
	productCompCdCondition: string;
	productItemCdCondition: string;
	productItemNm: string;
	productWorkplaceCdCondition: string;
}

export interface Store_TQC3020_R01 {
	// 탭 상태
	TQC3020_R01activeTab: TQC3020_R01_TabType;
	setTQC3020_R01ActiveTab: (tab: TQC3020_R01_TabType) => void;
	
	// 필터
	TQC3020_R01Filter: TQC3020_R01Filter;
	setTQC3020_R01Filter: (filter: Partial<TQC3020_R01Filter>) => void;
	
	// 매출기준 데이터
	TQC3020_R01dataList: TQC3020_R01SalesDto[];
	setTQC3020_R01SalesList: (list: TQC3020_R01SalesDto[]) => void;
	selectedTQC3020_R01Sales: TQC3020_R01SalesDto | undefined;
	setSelectedTQC3020_R01Sales: (data: TQC3020_R01SalesDto | undefined) => void;
	TQC3020_R01salesLotList: TQC3020_R01SalesLotDto[];
	setTQC3020_R01SalesLotList: (list: TQC3020_R01SalesLotDto[]) => void;
	selectedTQC3020_R01SalesLot: TQC3020_R01SalesLotDto | undefined;
	setSelectedTQC3020_R01SalesLot: (data: TQC3020_R01SalesLotDto | undefined) => void;
	TQC3020_R01salesAllCount: number;
	setTQC3020_R01SalesAllCount: (count: number) => void;
	
	// 생산기준 데이터
	TQC3020_R01productBaseList: TQC3020_R01ProductBaseDto[];
	setTQC3020_R01ProductBaseList: (list: TQC3020_R01ProductBaseDto[]) => void;
	selectedTQC3020_R01ProductBase: TQC3020_R01ProductBaseDto | undefined;
	setSelectedTQC3020_R01ProductBase: (data: TQC3020_R01ProductBaseDto | undefined) => void;
	TQC3020_R01productLotList: TQC3020_R01ProductLotDto[];
	setTQC3020_R01ProductLotList: (list: TQC3020_R01ProductLotDto[]) => void;
	selectedTQC3020_R01ProductLot: TQC3020_R01ProductLotDto | undefined;
	setSelectedTQC3020_R01ProductLot: (data: TQC3020_R01ProductLotDto | undefined) => void;
	
	// 하단 테이블 데이터
	TQC3020_R01productResultList: TQC3020_R01ProductResultDto[];
	setTQC3020_R01ProductResultList: (list: TQC3020_R01ProductResultDto[]) => void;
	selectedTQC3020_R01ProductResult: TQC3020_R01ProductResultDto | undefined;
	setSelectedTQC3020_R01ProductResult: (data: TQC3020_R01ProductResultDto | undefined) => void;
	TQC3020_R01bomList: TQC3020_R01BomDto[];
	setTQC3020_R01BomList: (list: TQC3020_R01BomDto[]) => void;
	selectedTQC3020_R01Bom: TQC3020_R01BomDto | undefined;
	setSelectedTQC3020_R01Bom: (data: TQC3020_R01BomDto | undefined) => void;
	TQC3020_R01stockList: TQC3020_R01StockDto[];
	setTQC3020_R01StockList: (list: TQC3020_R01StockDto[]) => void;
	selectedTQC3020_R01Stock: TQC3020_R01StockDto | undefined;
	setSelectedTQC3020_R01Stock: (data: TQC3020_R01StockDto | undefined) => void;
	
	// 컬럼 상태
	TQC3020_R01salesColumnState: ColumnState[] | null;
	setTQC3020_R01SalesColumnState: (state: ColumnState[] | null) => void;
	TQC3020_R01salesLotColumnState: ColumnState[] | null;
	setTQC3020_R01SalesLotColumnState: (state: ColumnState[] | null) => void;
	TQC3020_R01productBaseColumnState: ColumnState[] | null;
	setTQC3020_R01ProductBaseColumnState: (state: ColumnState[] | null) => void;
	TQC3020_R01productLotColumnState: ColumnState[] | null;
	setTQC3020_R01ProductLotColumnState: (state: ColumnState[] | null) => void;
	TQC3020_R01productResultColumnState: ColumnState[] | null;
	setTQC3020_R01ProductResultColumnState: (state: ColumnState[] | null) => void;
	TQC3020_R01bomColumnState: ColumnState[] | null;
	setTQC3020_R01BomColumnState: (state: ColumnState[] | null) => void;
	TQC3020_R01stockColumnState: ColumnState[] | null;
	setTQC3020_R01StockColumnState: (state: ColumnState[] | null) => void;

	TQC3020ScrollTop: TQC3020ScrollTop;
	setTQC3020ScrollTop: (key: TQC3020ScrollTopKey, top: number | null) => void;
	resetTQC3020ScrollTop: (keys: TQC3020ScrollTopKey[]) => void;
	resetAllTQC3020ScrollTop: () => void;
	
	// 초기화
	initData: () => void;
}

export const defaultTQC3020_R01Filter: TQC3020_R01Filter = {
	salesDateRange: {
		from: new Date(new Date().getFullYear(), 0, 1),
		to: new Date(new Date().getFullYear(), 11, 30),
	},
	salesCompCdCondition: '',
	salesCustomCdCondition: '',
	salesItemCd: '',
	salesItemNm: '',
	productDateRange: {
		from: new Date(new Date().getFullYear(), 0, 1),
		to: new Date(new Date().getFullYear(), 11, 30),
	},
	productCompCdCondition: '',
	productItemCdCondition: '',
	productItemNm: '',
	productWorkplaceCdCondition: '',
};

export const useTQC3020_R01Store = create<Store_TQC3020_R01>((set) => ({
	// 탭 상태
	TQC3020_R01activeTab: 'sales',
	setTQC3020_R01ActiveTab: (tab: TQC3020_R01_TabType) => set({ 
		TQC3020_R01activeTab: tab,
		// 탭 변경 시 하단 테이블 선택 상태 자동 초기화
		selectedTQC3020_R01ProductResult: undefined,
		selectedTQC3020_R01Bom: undefined,
		selectedTQC3020_R01Stock: undefined,
	}),
	
	// 필터
	TQC3020_R01Filter: defaultTQC3020_R01Filter,
	setTQC3020_R01Filter: (update) => set((state) => ({
		TQC3020_R01Filter: {
			...state.TQC3020_R01Filter,
			...update,
		},
	})),
	
	// 매출기준 데이터
	TQC3020_R01dataList: [],
	setTQC3020_R01SalesList: (list) => set((state) => {
		let newList: TQC3020_R01SalesDto[] = [];
		let valueIndex = 1;
		list.forEach((item) => {
			newList.push({
				...item,
				valueIndex: item.valueIndex && item.valueIndex > 0 ? item.valueIndex : valueIndex,
			});
			valueIndex++;
		});
		return { TQC3020_R01dataList: newList };
	}),
	selectedTQC3020_R01Sales: undefined,
	setSelectedTQC3020_R01Sales: (data) => set({ selectedTQC3020_R01Sales: data }),
	TQC3020_R01salesLotList: [],
	setTQC3020_R01SalesLotList: (list) => set((state) => {
		let newList: TQC3020_R01SalesLotDto[] = [];
		let valueIndex = 1;
		list.forEach((item) => {
			newList.push({
				...item,
				valueIndex: item.valueIndex && item.valueIndex > 0 ? item.valueIndex : valueIndex,
			});
			valueIndex++;
		});
		return { TQC3020_R01salesLotList: newList };
	}),
	selectedTQC3020_R01SalesLot: undefined,
	setSelectedTQC3020_R01SalesLot: (data) => set({ selectedTQC3020_R01SalesLot: data }),
	TQC3020_R01salesAllCount: 0,
	setTQC3020_R01SalesAllCount: (count) => set({ TQC3020_R01salesAllCount: count }),
	
	// 생산기준 데이터
	TQC3020_R01productBaseList: [],
	setTQC3020_R01ProductBaseList: (list) => set((state) => {
		let newList: TQC3020_R01ProductBaseDto[] = [];
		let valueIndex = 1;
		list.forEach((item) => {
			newList.push({
				...item,
				valueIndex: item.valueIndex && item.valueIndex > 0 ? item.valueIndex : valueIndex,
			});
			valueIndex++;
		});
		return { TQC3020_R01productBaseList: newList };
	}),
	selectedTQC3020_R01ProductBase: undefined,
	setSelectedTQC3020_R01ProductBase: (data) => set({ selectedTQC3020_R01ProductBase: data }),
	TQC3020_R01productLotList: [],
	setTQC3020_R01ProductLotList: (list) => set((state) => {
		let newList: TQC3020_R01ProductLotDto[] = [];
		let valueIndex = 1;
		list.forEach((item) => {
			newList.push({
				...item,
				valueIndex: item.valueIndex && item.valueIndex > 0 ? item.valueIndex : valueIndex,
			});
			valueIndex++;
		});
		return { TQC3020_R01productLotList: newList };
	}),
	selectedTQC3020_R01ProductLot: undefined,
	setSelectedTQC3020_R01ProductLot: (data) => set({ selectedTQC3020_R01ProductLot: data }),
	
	// 하단 테이블 데이터
	TQC3020_R01productResultList: [],
	setTQC3020_R01ProductResultList: (list) => set({ TQC3020_R01productResultList: list }),
	selectedTQC3020_R01ProductResult: undefined,
	setSelectedTQC3020_R01ProductResult: (data) => set({ selectedTQC3020_R01ProductResult: data }),
	TQC3020_R01bomList: [],
	setTQC3020_R01BomList: (list) => set((state) => {
		let newList: TQC3020_R01BomDto[] = [];
		let valueIndex = 1;
		list.forEach((item) => {
			newList.push({
				...item,
				valueIndex: item.valueIndex && item.valueIndex > 0 ? item.valueIndex : valueIndex,
			});
			valueIndex++;
		});
		return { TQC3020_R01bomList: newList };
	}),
	selectedTQC3020_R01Bom: undefined,
	setSelectedTQC3020_R01Bom: (data) => set({ selectedTQC3020_R01Bom: data }),
	TQC3020_R01stockList: [],
	setTQC3020_R01StockList: (list) => set((state) => {
		let newList: TQC3020_R01StockDto[] = [];
		let valueIndex = 1;
		list.forEach((item) => {
			newList.push({
				...item,
				valueIndex: item.valueIndex && item.valueIndex > 0 ? item.valueIndex : valueIndex,
			});
			valueIndex++;
		});
		return { TQC3020_R01stockList: newList };
	}),
	selectedTQC3020_R01Stock: undefined,
	setSelectedTQC3020_R01Stock: (data) => set({ selectedTQC3020_R01Stock: data }),
	
	// 컬럼 상태
	TQC3020_R01salesColumnState: null,
	setTQC3020_R01SalesColumnState: (state) => set({ TQC3020_R01salesColumnState: state }),
	TQC3020_R01salesLotColumnState: null,
	setTQC3020_R01SalesLotColumnState: (state) => set({ TQC3020_R01salesLotColumnState: state }),
	TQC3020_R01productBaseColumnState: null,
	setTQC3020_R01ProductBaseColumnState: (state) => set({ TQC3020_R01productBaseColumnState: state }),
	TQC3020_R01productLotColumnState: null,
	setTQC3020_R01ProductLotColumnState: (state) => set({ TQC3020_R01productLotColumnState: state }),
	TQC3020_R01productResultColumnState: null,
	setTQC3020_R01ProductResultColumnState: (state) => set({ TQC3020_R01productResultColumnState: state }),
	TQC3020_R01bomColumnState: null,
	setTQC3020_R01BomColumnState: (state) => set({ TQC3020_R01bomColumnState: state }),
	TQC3020_R01stockColumnState: null,
	setTQC3020_R01StockColumnState: (state) => set({ TQC3020_R01stockColumnState: state }),

	TQC3020ScrollTop: defaultTQC3020ScrollTop(),
	setTQC3020ScrollTop: (key, top) => set((state) => ({
		TQC3020ScrollTop: {
			...state.TQC3020ScrollTop,
			[key]: top,
		},
	})),
	resetTQC3020ScrollTop: (keys) => set((state) => {
		const next = { ...state.TQC3020ScrollTop };
		keys.forEach((key) => { next[key] = null; });
		return { TQC3020ScrollTop: next };
	}),
	resetAllTQC3020ScrollTop: () => set({ TQC3020ScrollTop: defaultTQC3020ScrollTop() }),
	
	// 초기화
	initData: () => set({
		TQC3020_R01Filter: defaultTQC3020_R01Filter,
		TQC3020_R01dataList: [],
		selectedTQC3020_R01Sales: undefined,
		TQC3020_R01salesLotList: [],
		selectedTQC3020_R01SalesLot: undefined,
		TQC3020_R01salesAllCount: 0,
		TQC3020_R01productBaseList: [],
		selectedTQC3020_R01ProductBase: undefined,
		TQC3020_R01productLotList: [],
		selectedTQC3020_R01ProductLot: undefined,
		TQC3020_R01productResultList: [],
		selectedTQC3020_R01ProductResult: undefined,
		TQC3020_R01bomList: [],
		selectedTQC3020_R01Bom: undefined,
		TQC3020_R01stockList: [],
		selectedTQC3020_R01Stock: undefined,
		TQC3020ScrollTop: defaultTQC3020ScrollTop(),
	}),
}));

